import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Container, Typography, TextField, Stack } from '@mui/material';
//
import whatsappFill from '@iconify/icons-ic/round-whatsapp';
import { Icon } from '@iconify/react';
import { LoadingButton } from '@mui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { varFadeInDown, varFadeInUp, varFadeIn, MotionInView } from '../../animate';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(15)
}));

// ----------------------------------------------------------------------

export default function LandingAdvertisement() {
  const isMountedRef = useIsMountedRef();
  const ContactSchema = Yup.object().shape({
    name: Yup.string().required('Le téléphone est requis'),
    subject: Yup.string().required('Le sujet est requis'),
    message: Yup.string().required('La message est requise')
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      subject: '',
      message: ''
    },
    validationSchema: ContactSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        const messageText = `Nom : ${values.name}%20%0ASujet : ${values.subject}%20%0A%0AMessage : ${values.message}`;
        window.open(`https://api.whatsapp.com/send?phone=+50935138181&text=${messageText}`, '_blank');
        if (isMountedRef.current) {
          setSubmitting(false);
        }
      } catch (error) {
        // alert(error);
        resetForm();
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: "Une erreur s'est produite!" });
        }
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <Container maxWidth="lg">
      <RootStyle>
        <MotionInView variants={varFadeIn}>
          <Box sx={{ p: 5, mt: 10, textAlign: 'center' }}>
            <MotionInView variants={varFadeInDown}>
              <Typography variant="h3">
                Contactez nous. <br />
                Nous serons heureux de vous entendre.
              </Typography>
            </MotionInView>

            <MotionInView variants={varFadeInDown}>
              <Typography sx={{ mt: 3, mb: 5, color: 'text.secondary' }}>
                Veuillez décrire votre cas pour recevoir les conseils les plus précis.
              </Typography>
            </MotionInView>

            <MotionInView variants={varFadeInUp}>
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <Stack spacing={3}>
                    <MotionInView variants={varFadeInUp}>
                      <TextField
                        fullWidth
                        autoComplete="name"
                        type="name"
                        label="Nom complet"
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </MotionInView>

                    <MotionInView variants={varFadeInUp}>
                      <TextField
                        fullWidth
                        autoComplete="subject"
                        label="Sujet"
                        {...getFieldProps('subject')}
                        error={Boolean(touched.subject && errors.subject)}
                        helperText={touched.subject && errors.subject}
                      />
                    </MotionInView>

                    <MotionInView variants={varFadeInUp}>
                      <TextField
                        fullWidth
                        label="Entrer votre message ici.."
                        {...getFieldProps('message')}
                        error={Boolean(touched.message && errors.message)}
                        helperText={touched.message && errors.message}
                        multiline
                        rows={4}
                      />
                    </MotionInView>
                    <MotionInView variants={varFadeInUp}>
                      <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                        sx={{ backgroundColor: 'green' }}
                        startIcon={<Icon icon={whatsappFill} width={20} height={20} />}
                      >
                        Envoyer avec whatsapp
                      </LoadingButton>
                    </MotionInView>
                  </Stack>
                </Form>
              </FormikProvider>
            </MotionInView>
          </Box>
        </MotionInView>
      </RootStyle>
    </Container>
  );
}
